<div class="p-4 md:p-8">
  <!-- Header -->
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-bottom: 24px;
    "
  >
    <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #1c593d"
      >account_balance_wallet</mat-icon
    >
    <h1 style="font-size: 1.4rem; font-weight: 800; color: #1e5a3f; margin: 0">
      Depósitos USDT
    </h1>
  </div>

  <!-- Balance Card -->
  <div
    style="
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 16px;
      max-width: 400px;
      margin: 0 auto 24px;
      overflow: hidden;
    "
  >
    <div
      style="
        background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
        padding: 16px 24px;
        border-bottom: 2px solid #bbf7d0;
        text-align: center;
      "
    >
      <span
        style="
          font-size: 0.75rem;
          color: #6b7280;
          font-weight: 600;
          text-transform: uppercase;
        "
        >Total USDT</span
      >
      <p
        style="
          font-size: 1.5rem;
          font-weight: 800;
          color: #1e5a3f;
          margin: 4px 0 0;
        "
      >
        ${{ saldoUsdtTotal | number: "1.2-2" }}
        <span style="font-size: 0.8rem; font-weight: 600; color: #6b7280"
          >USDT</span
        >
      </p>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2" style="padding: 0">
      <div
        *ngIf="saldoUsdtBloqueado > 0"
        style="
          padding: 14px 24px;
          text-align: center;
          border-bottom: 1px solid #e5e7eb;
        "
        [style.borderRight]="'1px solid #e5e7eb'"
      >
        <span
          style="
            font-size: 0.7rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
          "
          >Pendiente de envío</span
        >
        <p
          style="
            font-size: 1.1rem;
            font-weight: 700;
            color: #f59e0b;
            margin: 2px 0 0;
          "
        >
          ${{ saldoUsdtBloqueado | number: "1.2-2" }}
          <span style="font-size: 0.7rem; color: #6b7280">USDT</span>
        </p>
      </div>
      <div style="padding: 14px 24px; text-align: center">
        <span
          style="
            font-size: 0.7rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
          "
          >Saldo Disponible</span
        >
        <p
          style="
            font-size: 1.1rem;
            font-weight: 700;
            color: #1e5a3f;
            margin: 2px 0 0;
          "
        >
          ${{ saldoUsdtDisponible | number: "1.2-2" }}
          <span style="font-size: 0.7rem; color: #6b7280">USDT</span>
        </p>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div
    style="
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 24px;
    "
  >
    <button
      type="button"
      (click)="openModal()"
      style="
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        background: #1c593d;
        color: white;
        border: none;
        border-radius: 10px;
        font-weight: 700;
        font-size: 0.85rem;
        cursor: pointer;
        transition: background 0.2s ease;
      "
      onmouseover="this.style.background = '#059669'"
      onmouseout="this.style.background = '#1C593D'"
    >
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white"
        >download</mat-icon
      >
      Cargar USDT
    </button>
    <button
      *ngIf="userLoaded && tipoId !== 'VE'"
      type="button"
      (click)="navigateToConvert()"
      [disabled]="navigatingToConvert"
      [style.opacity]="navigatingToConvert ? '0.5' : '1'"
      [style.cursor]="navigatingToConvert ? 'not-allowed' : 'pointer'"
      style="
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        background: white;
        color: #1c593d;
        border: 2px solid #1c593d;
        border-radius: 10px;
        font-weight: 700;
        font-size: 0.85rem;
        cursor: pointer;
        transition: all 0.2s ease;
      "
      onmouseover="if (!this.disabled) this.style.background = '#f0fdf4';"
      onmouseout="this.style.background = 'white'"
    >
      USDT → CLP
    </button>
    <button
      type="button"
      (click)="navigateToConvertVes()"
      [disabled]="navigatingToConvertVes"
      [style.opacity]="navigatingToConvertVes ? '0.5' : '1'"
      [style.cursor]="navigatingToConvertVes ? 'not-allowed' : 'pointer'"
      style="
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        background: white;
        color: #1c593d;
        border: 2px solid #1c593d;
        border-radius: 10px;
        font-weight: 700;
        font-size: 0.85rem;
        cursor: pointer;
        transition: all 0.2s ease;
      "
      onmouseover="if (!this.disabled) this.style.background = '#f0fdf4';"
      onmouseout="this.style.background = 'white'"
    >
      USDT → VES
    </button>
    <button
      type="button"
      (click)="refreshAll()"
      style="
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.2s ease;
      "
      onmouseover="
        this.style.background = '#f0fdf4';
        this.style.borderColor = '#34d399';
      "
      onmouseout="
        this.style.background = 'white';
        this.style.borderColor = '#e5e7eb';
      "
    >
      <mat-icon
        style="font-size: 20px; width: 20px; height: 20px; color: #1c593d"
        >refresh</mat-icon
      >
    </button>
  </div>

  <!-- Loading -->
  <div
    *ngIf="isLoading"
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 20px;
      gap: 12px;
    "
  >
    <mat-spinner diameter="36"></mat-spinner>
    <span style="font-size: 0.85rem; color: #6b7280; font-weight: 500"
      >Cargando pagos...</span
    >
  </div>

  <!-- Error global -->
  <div
    *ngIf="errorMessage"
    style="
      background: #fef2f2;
      border: 1px solid #fecaca;
      border-left: 4px solid #dc2626;
      border-radius: 10px;
      padding: 12px 20px;
      margin-bottom: 16px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    "
  >
    <span style="color: #991b1b; font-size: 0.85rem; font-weight: 500">{{
      errorMessage
    }}</span>
  </div>

  <!-- Navigation Loading Overlay -->
  <div *ngIf="navigatingToConvert" class="modal-backdrop" style="z-index: 9999">
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
      "
    >
      <mat-spinner diameter="40"></mat-spinner>
      <span style="color: white; font-size: 0.9rem; font-weight: 600"
        >Cargando...</span
      >
    </div>
  </div>

  <!-- ===== MODAL RECARGAR USDT ===== -->
  <div class="modal-backdrop" *ngIf="showModal">
    <div class="modal-container">
      <!-- Header -->
      <div
        style="
          background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
          padding: 20px 24px;
          border-bottom: 2px solid #bbf7d0;
        "
      >
        <div style="display: flex; align-items: center; gap: 10px">
          <mat-icon
            style="font-size: 24px; width: 24px; height: 24px; color: #1c593d"
            >download</mat-icon
          >
          <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f"
            >Recargar USDT</span
          >
        </div>
      </div>

      <!-- Content -->
      <div style="padding: 20px 24px">
        <!-- Loader wallets -->
        <div
          *ngIf="loadingWalletsInModal"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 30px;
            gap: 12px;
          "
        >
          <mat-spinner diameter="32"></mat-spinner>
          <span style="font-size: 0.85rem; color: #6b7280"
            >Cargando wallets...</span
          >
        </div>

        <div *ngIf="!loadingWalletsInModal">
          <!-- Select red -->
          <div style="margin-bottom: 16px">
            <label
              style="
                display: block;
                font-size: 0.8rem;
                font-weight: 600;
                color: #1e5a3f;
                margin-bottom: 6px;
              "
              >Seleccionar red:</label
            >
            <select
              [(ngModel)]="selectedNetwork"
              (change)="onNetworkChange()"
              style="
                width: 100%;
                padding: 12px 16px;
                border: 2px solid #e5e7eb;
                border-radius: 12px;
                font-size: 0.9rem;
                background: white;
                color: #374151;
                outline: none;
                cursor: pointer;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor = '#34d399'"
              onblur="this.style.borderColor = '#e5e7eb'"
            >
              <option *ngFor="let net of availableNetworks" [value]="net">
                {{ net }} — {{ networkLabel(net) }}
              </option>
            </select>
          </div>

          <!-- Wallet de depósito: única visualización, sin branding extra -->
          <div *ngIf="depositAddress" style="margin-bottom: 16px">
            <label
              style="
                display: block;
                font-size: 0.8rem;
                font-weight: 600;
                color: #1e5a3f;
                margin-bottom: 6px;
              "
              >Wallet de depósito:</label
            >
            <div
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 12px 16px;
                background: #f0fdf4;
                border: 1px solid #bbf7d0;
                border-radius: 12px;
                word-break: break-all;
              "
            >
              <span
                style="
                  flex: 1;
                  font-family: &quot;Courier New&quot;, monospace;
                  font-size: 0.85rem;
                  color: #1e5a3f;
                  font-weight: 500;
                "
              >
                {{ depositAddress }}
              </span>
              <button
                type="button"
                (click)="copyDepositAddress()"
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 34px;
                  height: 34px;
                  border: 1px solid #bbf7d0;
                  border-radius: 8px;
                  background: white;
                  cursor: pointer;
                "
                onmouseover="this.style.background = '#d1fae5'"
                onmouseout="this.style.background = 'white'"
              >
                <mat-icon
                  style="
                    font-size: 18px;
                    width: 18px;
                    height: 18px;
                    color: #1c593d;
                  "
                  >content_copy</mat-icon
                >
              </button>
            </div>
            <span
              *ngIf="copiedInDepositModal"
              style="
                display: block;
                margin-top: 4px;
                font-size: 0.75rem;
                font-weight: 600;
                color: #16a34a;
              "
            >
              ¡Dirección copiada!
            </span>
          </div>

          <!-- TXID input — solo cuando NO se usa wallet personal -->
          <div *ngIf="!usingPersonalWallet" style="margin-bottom: 16px">
            <label
              style="
                display: block;
                font-size: 0.8rem;
                font-weight: 600;
                color: #1e5a3f;
                margin-bottom: 6px;
              "
              >TXID:</label
            >
            <input
              type="text"
              [value]="txId"
              (input)="onTxIdInput($event)"
              placeholder="Ingresa TXID sin espacios"
              style="
                width: 100%;
                padding: 12px 16px;
                border: 2px solid #e5e7eb;
                border-radius: 12px;
                font-size: 0.9rem;
                background: white;
                color: #374151;
                outline: none;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor = '#34d399'"
              onblur="this.style.borderColor = '#e5e7eb'"
            />
          </div>

          <!-- Info para flujo admin (requiere TXID) -->
          <div
            *ngIf="!usingPersonalWallet"
            style="
              padding: 10px 14px;
              background: #f0fdf4;
              border: 1px solid #bbf7d0;
              border-radius: 10px;
              display: flex;
              align-items: flex-start;
              gap: 8px;
            "
          >
            <mat-icon
              style="
                font-size: 16px;
                width: 16px;
                height: 16px;
                color: #16a34a;
                margin-top: 2px;
              "
              >info</mat-icon
            >
            <span
              style="
                font-size: 0.78rem;
                color: #1e5a3f;
                font-weight: 500;
                line-height: 1.4;
              "
            >
              <b>Importante:</b> Espera a que tu exchange marque la operación
              como <b>Completada</b> antes de enviar tu TXID.
            </span>
          </div>

          <!-- Info para flujo wallet propia: acreditación automática -->
          <div
            *ngIf="usingPersonalWallet"
            style="
              padding: 10px 14px;
              background: #f0fdf4;
              border: 1px solid #bbf7d0;
              border-radius: 10px;
              display: flex;
              align-items: flex-start;
              gap: 8px;
            "
          >
            <mat-icon
              style="
                font-size: 16px;
                width: 16px;
                height: 16px;
                color: #16a34a;
                margin-top: 2px;
              "
              >check_circle</mat-icon
            >
            <span
              style="
                font-size: 0.78rem;
                color: #1e5a3f;
                font-weight: 500;
                line-height: 1.4;
              "
            >
              Tu depósito se acredita automáticamente, normalmente en menos
              de 5 minutos.
            </span>
          </div>

          <!-- Modal error -->
          <div
            *ngIf="modalErrorMessage"
            style="
              margin-top: 12px;
              background: #fef2f2;
              border: 1px solid #fecaca;
              border-left: 4px solid #dc2626;
              border-radius: 8px;
              padding: 8px 12px;
            "
          >
            <span style="color: #991b1b; font-size: 0.8rem; font-weight: 500">{{
              modalErrorMessage
            }}</span>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div
        style="
          display: flex;
          gap: 16px;
          padding: 16px 24px;
          border-top: 1px solid #e5e7eb;
          justify-content: flex-end;
          flex-wrap: wrap;
        "
      >
        <button
          type="button"
          (click)="closeModal()"
          style="
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 10px 28px;
            background: white;
            color: #374151;
            border: 1px solid #d1d5db;
            border-radius: 10px;
            font-weight: 600;
            font-size: 0.85rem;
            cursor: pointer;
            transition: all 0.2s ease;
          "
          onmouseover="this.style.background = '#f3f4f6'"
          onmouseout="this.style.background = 'white'"
        >
          {{ usingPersonalWallet ? "Cerrar" : "Cancelar" }}
        </button>
        <!-- Confirmar: solo cuando hay flujo admin (TXID + red admin wallet) -->
        <button
          *ngIf="!usingPersonalWallet"
          type="button"
          (click)="confirmReload()"
          [disabled]="isConfirming || loadingWalletsInModal"
          [style.opacity]="isConfirming || loadingWalletsInModal ? '0.5' : '1'"
          [style.cursor]="
            isConfirming || loadingWalletsInModal ? 'not-allowed' : 'pointer'
          "
          style="
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 10px 36px;
            background: #1c593d;
            color: white;
            border: none;
            border-radius: 10px;
            font-weight: 700;
            font-size: 0.9rem;
            cursor: pointer;
            transition: background 0.2s ease;
          "
          onmouseover="if (!this.disabled) this.style.background = '#059669';"
          onmouseout="this.style.background = '#1C593D'"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>

  <!-- ===== MODAL WALLETS DISPONIBLES ===== -->
  <div class="modal-backdrop" *ngIf="showWalletsModal">
    <div class="modal-container modal-lg">
      <div
        style="
          background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
          padding: 20px 24px;
          border-bottom: 2px solid #bbf7d0;
        "
      >
        <div style="display: flex; align-items: center; gap: 10px">
          <mat-icon
            style="font-size: 24px; width: 24px; height: 24px; color: #1c593d"
            >account_balance_wallet</mat-icon
          >
          <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f"
            >Wallets Disponibles</span
          >
        </div>
      </div>

      <div style="padding: 20px 24px; max-height: 60vh; overflow-y: auto">
        <div
          *ngIf="walletsLoading"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 30px;
            gap: 12px;
          "
        >
          <mat-spinner diameter="32"></mat-spinner>
          <span style="font-size: 0.85rem; color: #6b7280"
            >Cargando wallets...</span
          >
        </div>

        <div
          *ngIf="walletsError"
          style="
            background: #fef2f2;
            border: 1px solid #fecaca;
            border-left: 4px solid #dc2626;
            border-radius: 8px;
            padding: 8px 12px;
          "
        >
          <span style="color: #991b1b; font-size: 0.8rem">{{
            walletsError
          }}</span>
        </div>

        <!-- Wallets table desktop -->
        <div
          *ngIf="!walletsLoading && wallets.length > 0"
          class="hidden lg:block"
        >
          <div class="table-wrapper">
            <table class="wallets-table">
              <thead>
                <tr>
                  <th>Cripto</th>
                  <th>Red</th>
                  <th>Dirección</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let wallet of wallets">
                  <td>{{ wallet.crypto }}</td>
                  <td>{{ wallet.network }}</td>
                  <td
                    style="
                      font-family: &quot;Courier New&quot;, monospace;
                      font-size: 0.78rem;
                      word-break: break-all;
                    "
                  >
                    {{ wallet.address }}
                  </td>
                  <td>
                    <button
                      type="button"
                      title="Copiar"
                      (click)="copyWallet(wallet)"
                      style="
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 30px;
                        height: 30px;
                        border: 1px solid #d1d5db;
                        border-radius: 6px;
                        background: white;
                        cursor: pointer;
                      "
                      onmouseover="this.style.background = '#f0fdf4'"
                      onmouseout="this.style.background = 'white'"
                    >
                      <mat-icon
                        style="
                          font-size: 16px;
                          width: 16px;
                          height: 16px;
                          color: #1c593d;
                        "
                        >content_copy</mat-icon
                      >
                    </button>
                    <span
                      *ngIf="copiedWalletId === wallet.id"
                      style="
                        font-size: 0.7rem;
                        color: #16a34a;
                        font-weight: 600;
                        margin-left: 4px;
                      "
                      >Copiado!</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Wallets cards mobile -->
        <div *ngIf="!walletsLoading && wallets.length > 0" class="lg:hidden">
          <div class="flex flex-col gap-3">
            <div
              *ngFor="let wallet of wallets"
              style="
                background: white;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 14px 16px;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 8px;
                "
              >
                <span
                  style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f"
                  >{{ wallet.crypto }} - {{ wallet.network }}</span
                >
                <button
                  type="button"
                  (click)="copyWallet(wallet)"
                  style="
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    background: white;
                    cursor: pointer;
                  "
                >
                  <mat-icon
                    style="
                      font-size: 16px;
                      width: 16px;
                      height: 16px;
                      color: #1c593d;
                    "
                    >content_copy</mat-icon
                  >
                </button>
              </div>
              <span
                style="
                  font-family: &quot;Courier New&quot;, monospace;
                  font-size: 0.75rem;
                  color: #374151;
                  word-break: break-all;
                "
                >{{ wallet.address }}</span
              >
              <span
                *ngIf="copiedWalletId === wallet.id"
                style="
                  display: block;
                  margin-top: 4px;
                  font-size: 0.7rem;
                  color: #16a34a;
                  font-weight: 600;
                "
                >Copiado!</span
              >
            </div>
          </div>
        </div>

        <p
          *ngIf="!walletsLoading && wallets.length === 0"
          style="
            text-align: center;
            color: #9ca3af;
            font-size: 0.9rem;
            padding: 20px;
          "
        >
          No hay wallets activas.
        </p>
      </div>

      <div
        style="
          display: flex;
          gap: 16px;
          padding: 16px 24px;
          border-top: 1px solid #e5e7eb;
          justify-content: flex-end;
        "
      >
        <button
          type="button"
          (click)="closeWalletsModal()"
          style="
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 10px 28px;
            background: white;
            color: #374151;
            border: 1px solid #d1d5db;
            border-radius: 10px;
            font-weight: 600;
            font-size: 0.85rem;
            cursor: pointer;
            transition: all 0.2s ease;
          "
          onmouseover="this.style.background = '#f3f4f6'"
          onmouseout="this.style.background = 'white'"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>

  <!-- ===== CARDEX TABLE ===== -->
  <div
    style="
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 16px;
      overflow: hidden;
      margin-top: 8px;
    "
  >
    <div
      style="
        background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
        padding: 14px 24px;
        border-bottom: 2px solid #bbf7d0;
      "
    >
      <span style="font-size: 1rem; font-weight: 800; color: #1e5a3f"
        >Movimientos</span
      >
    </div>

    <!-- Loading cardex -->
    <div
      *ngIf="cardexLoading"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 20px;
        gap: 12px;
      "
    >
      <mat-spinner diameter="36"></mat-spinner>
      <span style="font-size: 0.85rem; color: #6b7280; font-weight: 500"
        >Cargando movimientos...</span
      >
    </div>

    <!-- Desktop table -->
    <div *ngIf="!cardexLoading" class="hidden lg:block">
      <div class="table-wrapper">
        <table class="cardex-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>TXID</th>
              <th>Moneda</th>
              <th>Red</th>
              <th>Monto</th>
              <th>Retiro</th>
              <th>Depósito</th>
              <th>Saldo</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let mov of cardex">
              <td>{{ mov.createdAt | date: "dd/MM/yyyy HH:mm" }}</td>
              <td
                style="
                  font-family: &quot;Courier New&quot;, monospace;
                  font-size: 0.75rem;
                  max-width: 120px;
                  word-break: break-all;
                "
              >
                {{ mov.txId }}
              </td>
              <td>{{ mov.coin }}</td>
              <td>{{ getNetworkLabel(mov.network) }}</td>
              <td style="font-weight: 700; color: #1e5a3f">
                {{ mov.amount | number: "1.2-8" }}
              </td>
              <td style="color: #dc2626; font-weight: 600">
                {{ mov.debe | number: "1.2-8" }}
              </td>
              <td style="color: #16a34a; font-weight: 600">
                {{ mov.haber | number: "1.2-8" }}
              </td>
              <td style="font-weight: 700; color: #1e5a3f">
                {{ mov.saldo | number: "1.2-8" }}
              </td>
              <td style="font-size: 0.78rem">
                {{ sanitizeDescription(mov.description) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Mobile cards (collapsible) -->
    <div *ngIf="!cardexLoading" class="lg:hidden" style="padding: 12px">
      <div class="flex flex-col gap-3">
        <div
          *ngFor="let mov of cardex; let i = index"
          style="
            background: white;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            overflow: hidden;
            transition: border-color 0.2s;
          "
          [style.borderColor]="
            expandedCardId === 'cardex-' + i ? '#34d399' : '#e5e7eb'
          "
        >
          <!-- Card header (clickable) -->
          <div
            (click)="toggleCard('cardex-' + i)"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 14px 16px;
              cursor: pointer;
            "
            [style.background]="
              expandedCardId === 'cardex-' + i ? '#f0fdf4' : 'white'
            "
          >
            <div style="display: flex; flex-direction: column; gap: 2px">
              <span style="font-size: 0.78rem; color: #6b7280">{{
                mov.createdAt | date: "dd/MM/yyyy HH:mm"
              }}</span>
              <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f"
                >{{ mov.amount | number: "1.2-8" }} {{ mov.coin }}</span
              >
            </div>
            <div style="display: flex; align-items: center; gap: 8px">
              <span
                *ngIf="mov.haber > 0"
                style="
                  font-size: 0.7rem;
                  font-weight: 700;
                  padding: 2px 8px;
                  border-radius: 6px;
                  background: #dcfce7;
                  color: #16a34a;
                "
                >+{{ mov.haber | number: "1.2-2" }}</span
              >
              <span
                *ngIf="mov.debe > 0"
                style="
                  font-size: 0.7rem;
                  font-weight: 700;
                  padding: 2px 8px;
                  border-radius: 6px;
                  background: #fef2f2;
                  color: #dc2626;
                "
                >-{{ mov.debe | number: "1.2-2" }}</span
              >
              <mat-icon
                style="
                  font-size: 18px;
                  width: 18px;
                  height: 18px;
                  color: #9ca3af;
                  transition: transform 0.2s;
                "
                [style.transform]="
                  expandedCardId === 'cardex-' + i
                    ? 'rotate(180deg)'
                    : 'rotate(0)'
                "
              >
                expand_more
              </mat-icon>
            </div>
          </div>
          <!-- Card body (expanded) -->
          <div
            *ngIf="expandedCardId === 'cardex-' + i"
            style="padding: 0 16px 14px; border-top: 1px solid #f3f4f6"
          >
            <div
              class="grid grid-cols-2 gap-2"
              style="margin-top: 12px; margin-bottom: 8px"
            >
              <div>
                <span
                  style="
                    font-size: 0.65rem;
                    font-weight: 600;
                    color: #6b7280;
                    text-transform: uppercase;
                  "
                  >Monto</span
                >
                <p
                  style="
                    font-size: 0.85rem;
                    font-weight: 700;
                    color: #1e5a3f;
                    margin: 0;
                  "
                >
                  {{ mov.amount | number: "1.2-8" }}
                </p>
              </div>
              <div>
                <span
                  style="
                    font-size: 0.65rem;
                    font-weight: 600;
                    color: #6b7280;
                    text-transform: uppercase;
                  "
                  >Saldo</span
                >
                <p
                  style="
                    font-size: 0.85rem;
                    font-weight: 700;
                    color: #1e5a3f;
                    margin: 0;
                  "
                >
                  {{ mov.saldo | number: "1.2-8" }}
                </p>
              </div>
              <div>
                <span
                  style="
                    font-size: 0.65rem;
                    font-weight: 600;
                    color: #6b7280;
                    text-transform: uppercase;
                  "
                  >Retiro</span
                >
                <p
                  style="
                    font-size: 0.85rem;
                    font-weight: 600;
                    color: #dc2626;
                    margin: 0;
                  "
                >
                  {{ mov.debe | number: "1.2-8" }}
                </p>
              </div>
              <div>
                <span
                  style="
                    font-size: 0.65rem;
                    font-weight: 600;
                    color: #6b7280;
                    text-transform: uppercase;
                  "
                  >Depósito</span
                >
                <p
                  style="
                    font-size: 0.85rem;
                    font-weight: 600;
                    color: #16a34a;
                    margin: 0;
                  "
                >
                  {{ mov.haber | number: "1.2-8" }}
                </p>
              </div>
            </div>
            <div style="font-size: 0.75rem; color: #6b7280">
              <span style="font-weight: 600">Red:</span>
              {{ getNetworkLabel(mov.network) }}
            </div>
            <div
              *ngIf="mov.txId"
              style="
                font-size: 0.7rem;
                color: #6b7280;
                margin-top: 4px;
                word-break: break-all;
              "
            >
              <span style="font-weight: 600">TXID:</span>
              <span style="font-family: &quot;Courier New&quot;, monospace">{{
                mov.txId
              }}</span>
            </div>
            <div
              *ngIf="sanitizeDescription(mov.description)"
              style="font-size: 0.72rem; color: #6b7280; margin-top: 4px"
            >
              {{ sanitizeDescription(mov.description) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <div
      *ngIf="!cardexLoading"
      style="padding: 8px 16px; border-top: 1px solid #e5e7eb"
    >
      <mat-paginator
        [length]="cardexTotal"
        [pageSize]="cardexLimit"
        [disabled]="false"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 20, 50, 100]"
        [hidePageSize]="false"
        [pageIndex]="cardexPage - 1"
        aria-label="Select page"
        (page)="onCardexPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
